module.exports = __webpack_public_path__ + "img/easter_tour_3.9538d83a.png";